<template>
    <div
        class="alert alert-dismissible"
        :class="'alert-'+getFlashType"
        role="alert"
    >
        {{ message }}

        <button type="button" class="btn-close" aria-label="Close" @click.prevent="$emit('close')"></button>
    </div>
</template>

<script setup lang="ts">
import {computed} from "vue";
import type {FlashType} from "@/components/helpers/Interfaces.ts";

defineEmits<{
    (e: 'close')
}>()

const TYPES = ['primary', 'secondary', 'success', 'danger', 'warning', 'info', 'light', 'dark'];
const {message, type = 'info'} = defineProps<{
    message: string,
    type: FlashType
}>()

const getFlashType = computed(() => {
    if(TYPES.includes(type.toString().toLowerCase())) {
        return type.toString().toLowerCase();
    }

    return 'info';
})
</script>

<style scoped>

</style>
